import { render } from "./ListeClient.vue?vue&type=template&id=0243b486&ts=true"
import script from "./ListeClient.vue?vue&type=script&lang=ts"
export * from "./ListeClient.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__